import { render } from "./SalesDiscountsListPage.vue?vue&type=template&id=797f849c&ts=true"
import script from "./SalesDiscountsListPage.vue?vue&type=script&lang=ts"
export * from "./SalesDiscountsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__